import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 19v-7a5 5 0 1 1 10 0v7","key":"svg-0"}],["path",{"d":"M12 5v14","key":"svg-1"}]]

const IconCurrencyManat = createReactComponent('outline', 'currency-manat', 'CurrencyManat', __iconNode);

export default IconCurrencyManat;